import { determineCategoryApiUrl } from './urls';
import { CategoryApiResponse } from 'models/CategoryApiResponse';
import { CategoryApiRequestParams } from 'models/CategoryApiRequestParams';

export const getCategoriesFromApi = async ({
  environment,
  targetMarket
}: CategoryApiRequestParams): Promise<CategoryApiResponse> => {
  const url = new URL(determineCategoryApiUrl(environment));
  url.searchParams.append('targetMarket', targetMarket);

  const response: Response = await fetch(url.toString());
  return (await response.json()) as CategoryApiResponse;
};
